interface SlotDurationSelectorProps {
  value: 15 | 30 | 45 | 60;
  onChange: (duration: 15 | 30 | 45 | 60) => void;
}

const durations = [
  { value: 15, label: "15 min" },
  { value: 30, label: "30 min" },
  { value: 45, label: "45 min" },
  { value: 60, label: "60 min" },
];

export default function SlotDurationSelector({ value, onChange }: SlotDurationSelectorProps) {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">Slot Duration</label>
      <div className="flex space-x-2">
        {durations.map((duration) => (
          <button
            key={duration.value}
            onClick={() => onChange(duration.value as 15 | 30 | 45 | 60)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              value === duration.value ? "bg-blue-500 text-white" : "bg-gray-50 text-gray-700 hover:bg-gray-100"
            }`}
          >
            {duration.label}
          </button>
        ))}
      </div>
    </div>
  );
}
